import { EVENT_APPRAISER_ASSIGNMENT_ROLE } from '../../../../constants/EventAppraiserAssignmentRole';
import { EVENT_APPRAISER_ASSIGNMENT_STATUS } from '../../../shared/constants';

export const userAssignmentService = {
  isPrimaryAndAcceptedAssignment(role, status) {
    return (
      role === EVENT_APPRAISER_ASSIGNMENT_ROLE.PRIMARY &&
      (status === EVENT_APPRAISER_ASSIGNMENT_STATUS.ACCEPTED ||
        status === EVENT_APPRAISER_ASSIGNMENT_STATUS.PENDING_CONFIRMATION)
    );
  },
  isPrimary(role) {
    return role === EVENT_APPRAISER_ASSIGNMENT_ROLE.PRIMARY;
  },
  isAssigned(role) {
    return (
      role === EVENT_APPRAISER_ASSIGNMENT_ROLE.PRIMARY ||
      role === EVENT_APPRAISER_ASSIGNMENT_ROLE.SECONDARY
    );
  }
};
